export const featuresFree = [
  'premium.free.create_invoices',
  'premium.free.send_invoices',
  'premium.free.customer_products',
  'premium.free.reports',
]
export const featuresStarter = [
  'premium.feature.estimates_to_invoices',
  'premium.feature.reminders',
  'premium.feature.email_attachments',
  'premium.feature.tpayment_link',
]
export const featuresPro = [
  'premium.feature.tradenames',
  'premium.feature.time_tracking',
  'premium.feature.payment_schedules',
  'premium.feature.recurring_profiles',
  'premium.feature.banking',
]

const previewCard = 'checkout_preview.preview_card'
const transaction = 'checkout_preview.transaction'
export default {
  eInvoiceModal: {
    ovtHint: 'e-invoice-modal.ovt-hint',
    addressInvalid: 'e-invoice-modal.address-invalid', // Incorrect %scheme address
  },
  modalHeader: 'subscription.modal_top_header',
  paymentModalHeader: 'subscription.payment_modal_header',
  infoHeader: 'subscription.modal_info_header',
  infoText: 'subscription.modal_info_text',
  modalUpgradeHeader: 'subscription.modal_top_header_upgrade',
  infoUpgradeHeader: 'subscription.modal_info_header_upgrade',
  infoUpgradeText: 'subscription.modal_info_text_upgrade',
  infoUpgradeTrialText: 'subscription.modal_info_text_trial_upgrade',
  pay: 'subscription.modal_pay',
  creditCardNuber: 'subscription.card_number',
  creditCardExpiration: 'subscription.card_expiry',
  creditCardCVC: 'subscription.card_cvc',
  cardHoldersName: 'subscription.card_holders_name',
  invoiceEmail: 'subscription.invoice_email',
  processingPaymentMethod: 'subscription.processing_payment_method',
  vat_FI: 'subscription.vat_FI',
  vat_DK: 'subscription.vat_DK',
  vat_0: 'subscription.vat_0',
  premiumInvoicesPerMonth: 'subscription.premium_invoices_per_month',
  premiumInvoicesPerYear: 'subscription.premium_invoices_per_year',
  billingPeriodLabel: 'subscription.billing_period_label',
  billingPeriod1Month: 'subscription.billing_period_1_month',
  billingPeriod1Year: 'subscription.billing_period_1_year',
  price: 'subscription.price',
  totalPrice: 'subscription.total_price',
  vatNumber: 'subscription.vat_number',
  monthlyPrice: 'subscription.monthly_price',
  yearlyPrice: 'subscription.yearly_price',
  subscribe: 'subscription.subscribe',
  upgradeChangeMonthly: 'subscription.upgrade-change-monthly',
  upgrade: 'subscription.upgrade',
  downgrade: 'subscription.downgrade',
  changeDowngrade: 'subscription.change-downgrade',
  paymentMethod: 'subscription.payment_method',
  editPaymentMethod: 'subscription.edit_payment_method',
  saveMethodAndPay: 'subscription.save_payment_method_and_subscribe',
  updatePaymentMethod: 'subscription.update_payment_method',
  totalUpgradedPrice: 'subscription.total_upgraded_plan_price',
  deductedFromCurrent: 'subscription.deducted_from_current',
  freeTrialLabel: 'subscription.free_trial_label',
  nextPaymentDue: 'subscription.next_payment_due',
  startFreeTrial: 'subscription.start_free_trial',
  subscriptionsHeader: 'subscription.menu_header',
  currentLabel: 'subscription.current_label',
  menuInfoHeader: 'subscription.menu_info_header',
  menuInfoText: 'subscription.menu_info_text',
  mostPopular: 'subscription.most_popular',
  subscriptionCancellationDiscountYearly: 'subscription.yr-cancellation_discount',
  subscriptionCancellationDiscountMonthly: 'subscription.m-cancellation_discount',
  subscriptionCancellationDiscountPercentage: 'subscription.cancellation_discount_percentage',
  loadingPlans: 'subscription.loading_plans',
  nextPaymentDate: 'subscription.next_payment_date',
  priceForCurrent: 'subscription.price_for_current_month',
  days: 'loanCalculator.table.days',
  invoicesEstimates: 'subscription.invoices_estimates',
  limitedInvoicesEstimates: 'subscription.free_invoice_limited',

  downGradeModalHeader: 'subscription.downgrade_modal_header',
  downGradeInfoHeader: 'subscription.downgrade_info_header',
  downGradeInfoParagraph: 'subscription.downgrade_info_paragraph',
  downgradeCurrentPlan: 'subscription.downgrade_current_plan',
  downgradeNewPlan: 'subscription.downgrade_new_plan',
  month: 'subscription.month',
  startDate: 'subscription_downgrade_start_date',
  validUntil: 'subscription.valid_until',
  downgraded: 'subscription.downgraded',
  processingSubscription: 'subscription.processing',
  processingDowngrade: 'subscription.processing_downgrade',
  save: 'save',
  editPaymentDetails: 'account.editPaymentDetails',

  downgradeNotification: 'notification.subscription.downgrade',
  cancelNotification: 'notification.subscription.cancel',
  firstSubscribeNotification: 'notification.subscription.firstSubscribe',
  updatePaymentMethodNotification: 'notification.subscription.updatePaymentMethod',
  subscriptionPlanUpgradedNotification: 'notification.subscription.subscriptionPlanUpgraded',
  subscriptionAuthorizationFailedNotification: 'notification.subscription.authorizationFailed',
  paymentDeclinedHeading: 'subscription.payment_declined_heading',
  paymentDeclinedDescription: 'subscription.payment_declined_description',

  cancelModalHeader: 'subscription.cancel_modal_header',
  cancelInfoHeader: 'subscription.cancel_info_header',
  cancelInfoParagraph: 'subscription.cancel_info_paragraph',
  cancelInTrialWarning: 'subscription.cancel_in_trial_warning',
  cancelPaidWarning: 'subscription.cancel_paid_warning',
  processingCancelation: 'subscription.processing_cancelation',
  cancelFailed: 'notification.subscription.cancel_failed',
  cancelSubscription: 'subscription.cancel_plan',
  dontCancelSubscription: 'subscription.dont_cancel',
  cardEndingWith: 'subscription.card_ending_with',

  freePlan: 'subscription.free_plan',
  sendByPostMarketingTitle: 'subscription.send_by_post_marketing_title',
  sendByPostMarketingText: 'subscription.send_by_post_marketing_text',
  freeTrialMarketingTitle: 'subscription.free_trial_marketing_title',
  freeTrialMarketingText: 'subscription.free_trial_marketing_text',
  sendByEInvoiceMarketingTitle: 'subscription.send_by_einvoice_marketing_title',
  sendByEInvoiceMarketingText: 'subscription.send_by_einvoice_marketing_text',
  valueMarketingTitle: 'subscription.value_marketing_title',
  valueMarketingText: 'subscription.value_marketing_text',
  freeVersionTitle: 'subscription.free_version_title',
  freeVersionText: 'subscription.free_version_text',
  sendReminderMarketingTitle: 'subscription.send_reminder_marketing_title',
  sendReminderMarketingText: 'subscription.send_reminder_marketing_text',
  trackerMarketingTitle: 'subscription.tracker_marketing_title',
  trackerMarketingText: 'subscription.tracker_marketing_text',

  premiumMarketingTitle: 'subscription.premium_marketing_title',
  premiumMarketingText: 'subscription.premium_marketing_text',

  convertEstimateMarketingTitle: 'subscription.convert_estimate_marketing_title',
  convertEstimateMarketingText: 'subscription.convert_estimate_marketing_text',

  tradenamesMarketingTitle: 'subscription.tradenames_marketing_title',
  tradenamesMarketingText: 'subscription.tradenames_marketing_text',

  customersMarketingTitle: 'subscription.customers_marketing_title',
  customersMarketingText: 'subscription.customers_marketing_text',

  paymentSchedulesMarketingTitle: 'subscription.payment_schedules_marketing_title',
  paymentSchedulesMarketingText: 'subscription.payment_schedules_marketing_text',

  trialEndWarning: 'subscription.trial_end_warning_when_upgrade',
  menuInfoHeaderWithSubscription: 'subscription.menu_info_header_with_subscription',
  menuInfoTextWithSubscription: 'subscription.menu_info_text_with_subscription',

  premiumPlansTitle: 'subscription.premium-modal.no_subscription_without_referral.title',
  premiumPlansDesc: 'subscription.premium-modal.no_subscription_without_referral.description',
  premiumPlansFeatures: 'subscription.premium-modal.no_subscription_without_referral.description',

  trial: 'subscription.trial',
  trialLeft: 'subscription.trial_left',

  seePlans: 'subscription.see_plans',
  upgradeToPremiumAd: 'subscription.upgrade_to_premium_ad',

  bannerText: 'subscription.banner_text',
  vatNumberInfo: 'subscription.vat_number_info',
  quotaLeft: 'subscription.quota_left',

  plan: 'subscription.plan',
  freePlanMessage: 'subscription.on_free_plan',

  cancelled: 'subscription.cancelled',
  preCancellationNote: 'subscription.pre_cancellation_note',
  postCancellationNote: 'subscription.post_cancellation_note',

  reminderFeature: 'subscription.reminder_feature_label',
  reminderFeatureValue: 'subscription.reminder_feature_label_value',

  customersFeature: 'subscription.customers_feature_label',
  customersFeatureValue: 'subscription.customers_feature_label_value',

  trackerFeature: 'subscription.tracker_feature_label',
  trackerFeatureValue: 'subscription.tracker_feature_label_value',
  tradenamesFeature: 'subscription.tradenames_feature_label',
  downPayment: 'subscription.down_payment_label',
  onlineBankPayments: 'subscription.tpayment_link',
  estimateConvertFeature: 'subscription.estimate_convert_feature_label',
  paymentScheduleFeature: 'subscription.payment_schedule_feature_label',
  emailAttachmentFeature: 'subscription.email_attachment_feature_label',
  recurringProfileFeature: 'subscription.recurring_profile_feature_label',
  freeReportsFeature: 'subscription.free_reports_feature_label',
  freeSendEmailAndPdf: 'subscription.free_send_email_and_pdf_feature_label',
  freeProductsFeature: 'subscription.free_products_feature_label',
  freeCreateInvoiceFeature: 'subscription.free_invoice_feature_label',
  freeCreateEstimatesFeature: 'subscription.free_estimates_feature_label',
  documentCustomisationFeature: 'subscription.document_customisation_feature_label',
  freeMobileApp: 'subscription.free_mobile_app',
  banking: 'subscription.banking_feature_label',
  bankReconciliation: 'subscription.bank_reconciliation_feature_label',
  autoBankReconciliation: 'subscription.auto_bank_reconciliation_feature_label',
  expenses: 'subscription.expenses_feature_label',
  AIExpensesCategorization: 'subscription.AI_expenses_categorization_feature_label',
  bookkeepingSupport: 'subscription.bookkeeping_support_feature_label',
  accountantAccess: 'subscription.accountant_access_feature_label',
  VATReturns: 'subscription.VAT_returns_feature_label',
  receiptScanning: 'subscription.receipt_scanning_feature_label',
  onlineCardPayments: 'subscription.online_card_payments_feature_label',
  postalInvoice: 'subscription.postal_invoice_feature_label',
  eInvoice: 'subscription.e_invoice_feature_label',
  cancelSubscriptionTitle: 'subscription.cancelTitle',
  contactSupport: 'subscription.myAccount.contactSupport',
  contactSupportLink: 'subscription.myAccount.contactSupport.link', // with variable %email%
  myAccountTestingGroupA: 'subscription.myAccount.testingGroupA',
  cancelSubscriptionTestingGroupA: 'subscription.cancel.testingGroupA',
  subscriptionInfoBox: {
    customers: {
      header: 'subscription.infobox.customers.header',
      body: 'subscription.infobox.customers.body',
      upgrade: 'subscription.infobox.customers.upgrade',
    },
    freeInvoices: {
      header: 'subscription.infobox.freeInvoices.header',
      body: 'subscription.infobox.freeInvoices.body',
      upgrade: 'subscription.infobox.freeInvoices.upgrade',
    },
    all: {
      customers: {
        header: 'subscription.infobox.all.customers.header',
        body: 'subscription.infobox.all.customers.body',
      },
    },
  },
  stripeErrors: {
    header: 'stripe.error.header',
    incorrect_cvc: 'stripe.error.incorrect_cvc',
    insufficient_funds: 'stripe.error.insufficient_funds',
    expired_card: 'stripe.error.expired_card',
    generic_error: 'stripe.error.generic',
  },
  sepa: {
    SepaProcessingFee: 'subscription.sepa.processing_fee',
    IBANLabel: 'subscription.sepa.iban_form_label',
    accountHolderLabel: 'subscription.sepa.account_holder_form_label',
    paymentOptionLabel: 'subscription.sepa.option_label',
    authorizationDisclaimer: 'subscription.sepa.authorization_disclaimer',
    sepaTermHeader: 'subscription.sepa.sepa_term_header',
    sepaTerm_1: 'subscription.sepa.sepa_term_1',
    sepaTerm_2: 'subscription.sepa.sepa_term_2',
    sepaTerm_3: 'subscription.sepa.sepa_term_3',
    sepaTerm_4: 'subscription.sepa.sepa_term_4',
    sepaTerm_5: 'subscription.sepa.sepa_term_5',
    sepaTermAgree: 'subscription.sepa.sepa_term_agree',
    error: {
      methodNotAvailable: 'subscription.sepa.error.payment_method_not_available',
      processingError: 'subscription.sepa.error.processing_error',
      invalidIban: 'subscription.sepa.error.invalid_bank_account_iban',
      invalidOwner: 'subscription.sepa.error.invalid_owner_name',
      genericError: 'subscription.sepa.error.genetic_error',
    },
    paymentDetailsTitle: 'subscription.sepa.payment_details_title',
    paymentIbanLast4: 'subscription.sepa.payment_details_iban_last4',
    showMandate: 'subscription.sepa.show_mandate',
  },
  creditcardpaymentDetailsTitle: 'subscription.creditcard.details.title',
  creditcardPaymentOptionLabel: 'subscription.creditcard.option.label',
  endingWith: 'subscription.creditcard.ending_with',
  noPaymentMethod: 'subscription.no_payment_method',
  addPaymentMethod: 'subscription.add_payment_method',
  myPlan: {
    loading: 'subscription.my_plan.loading',
    header: 'subscription.my_plan.header',
    trialLeft: 'subscription.my_plan.trial_left',
    footer: {
      trial_with_referral: 'subscription.my_plan.footer.trial_with_referral',
      trial_without_referral: 'subscription.my_plan.footer.trial_without_referral',
      para_with_referral: 'subscription.my_plan.footer.para_with_referral',
      para_without_referral: 'subscription.my_plan.footer.para_without_referral',
      para: 'subscription.my_plan.footer.para',
      nextPayment: 'subscription.my_plan.footer.next_payment',
      startDate: 'subscription_downgrade_start_date',
      cancelSubscription: 'subscription.my_plan.footer.cancel_subscription',
      info_box: {
        header: 'subscription.my_plan.footer.info_box.header',
        paragraph: 'subscription.my_plan.footer.info_box.paragraph',
        read_more_button: 'subscription.my_plan.footer.info_box.read_more_button',
        read_more_button_link: 'subscription.my_plan.footer.info_box.read_more_button_link',
      },
    },
    viewPlans: 'subscription.my_plan.view_plans',
    quotaInfo: {
      invoice: 'subscription.my_plan.quota_info.invoice',
      invoiceYear: 'subscription.my_plan.quota_info.invoice_year',
      customers: 'subscription.my_plan.quota_info.customers',
      unlimited: 'subscription.my_plan.quota_info.unlimited',
      price: 'subscription.my_plan.quota_info.price',
      priceYear: 'subscription.my_plan.quota_info.price_year',
      free: 'subscription.my_plan.quota_info.free',
      freeInvoiceLimit: 'subscription.my_plan.quota_info.free_invoice_limit',
    },
    downgrade: {
      downgraded: 'subscription.my_plan.downgrade.downgraded',
      cancelled: 'subscription.my_plan.downgrade.cancelled',
      startsAt: 'subscription.my_plan.downgrade.starts_at', // 'New plan starting at %date'
      validUntil: 'subscription.my_plan.downgrade.valid_until', // 'Current plan valid until %date'
    },
  },
  allPlansInclude: 'subscription.all-plans-include',
  premiumPlanModal: {
    cancelDowngrade: 'premium-plan-modal.plan.cancel_downgrade',
    allFeaturesInclude: 'premium-plan-modal.all-plans-include',
    newPlan: 'premium-plan-modal.plan.new-plan',
    downgraded: 'premium-plan-modal.plan.downgraded',
    planStarting: 'premium-plan-modal.plan.starting',
    planEnding: 'premium-plan-modal.plan.ending',
    featuresGroup: {
      invoicing: 'premium-plan-modal.featuresGroup.invoicing',
      accounting: 'premium-plan-modal.featuresGroup.accounting',
      admin: 'premium-plan-modal.featuresGroup.admin',
    },
  },
  checkoutPreview: {
    headers: {
      trial: {
        header: 'checkout_preview.headers.trial.header',
        info: 'checkout_preview.headers.trial.info', // 'Try plan with all features for free for %days days'
      },
      upgradeTrial: {
        header: 'checkout_preview.headers.upgrade_trial.header',
        info: 'checkout_preview.headers.upgrade_trial.info', // 'Continue your %days day free trial..'
      },
      upgrade: {
        header: 'checkout_preview.headers.upgrade.header',
        monthly: 'checkout_preview.headers.upgrade_monthly.header',
        monthlyInfo: 'checkout_preview.headers.upgrade_monthly.description',
        yearlyNoRef: 'subscription.checkout-page.no_subscription_without_referral_yearly.title',
        yearlyWithRef: 'subscription.checkout-page.no_subscription_with_referral_yearly.title',
      },
      reSubscribe: {
        header: 'checkout_preview.headers.re_subscribe.header',
        monthlyHeader: 'subscription.checkout-page.no_subscription.free.title',
        monthlyDesc: 'subscription.checkout-page.no_subscription.free.description',
      },
      downgrade: {
        header: 'checkout_preview.headers.downgrade.header',
        info: 'checkout_preview.headers.downgrade.info',
      },
    },
    previewCard: {
      header: {
        description: `${previewCard}.header.description`, // %days day free trial
        descriptionUpgradeTrial: `${previewCard}.header.description_upgrade_trial`,
        // %days day free trial (%daysleft days left)
        changePlan: `${previewCard}.header.change_plan`,
      },
      total: {
        nextPayment: `${previewCard}.total.next_payment`,
        freeTrial: {
          firstPayment: `${previewCard}.total.free_trial.first_payment`, // First payment %date,
          total: `${previewCard}.total.free_trial.total`,
        },
      },
    },
    transaction: {
      start: {
        freeTrial: `${transaction}.start.free_trial`, // Start %days free trial
        upgradeTrial: `${transaction}.upgrade.free_trial`,
      },
      pay: `${transaction}.pay`, // Pay (%price),
      saveAndPay: `${transaction}.save_and_pay`, // Save and Pay (%price)
      downgrade: `${transaction}.downgrade`,
      downgradeToAnnual: `${transaction}.downgradeToAnnual`,
      overdue: {
        pay: `${transaction}.overdue.pay`,
        sepaDisputed: `${transaction}.overdue.sepa-disputed`,
        cardFailed: `${transaction}.overdue.card-failed`,
        viewAndPay: `${transaction}.overdue.view-and-pay`,
      },
      freeTrial: `${transaction}.free_trial-reminder`,
    },
    notification: {
      upgrade: 'notification.subscription.subscriptionPlanUpgraded', // old
      downgrade: 'notification.subscription.plan_downgraded',
    },
    compareDowngrade: {
      month: 'month', // old
      year: 'year', // old
      newPlan: 'subscription.downgrade_new_plan', // old
      currentPlan: 'subscription.downgrade_current_plan', // old
    },
  },
  menuInfoHeaderWith14DayEmphasis: 'subscription.menu_info_header_with_14_day_emphasis',
  menuInfoTextWith14DayEmphasis: 'subscription.menu_info_text_with_14_day_emphasis',
  invoices: {
    total: 'subscription.invoices.total',
    item: 'subscription.invoices.item',
    receipt: 'subscription.invoices.receipt',
    pdf: 'subscription.invoices.pdf',
    view: 'subscription.invoices.view',
    viewLink: 'subscription.invoices.view_link',
    download: 'subscription.invoices.download',
    overviewTab: 'subscription.invoices.overview_tab',
    historyTab: 'subscription.invoices.history_tab',
  },
  authorize: {
    infoTitle: 'subscription.authorize.info_title',
    infoMessage: 'subscription.authorize.info_message',
    infoAction: 'subscription.authorize.info_action',
  },
  pastDue: {
    infoTitle: 'subscription.pastDue.info_title',
    infoMessage: 'subscription.pastDue.info_message',
    infoAction: 'subscription.pastDue.info_action',
    banner: {
      infoTitle: 'subscription.pastDue.banner.info_title',
      infoMessage: 'subscription.pastDue.banner.info_message',
      infoAction: 'subscription.pastDue.banner.info_action',
    },
  },
  updatedPastDue: {
    infoTitle: 'subscription.updatedPastDue.info_title',
    infoMessage: 'subscription.updatedPastDue.info_message',
    infoAction: 'subscription.updatedPastDue.info_action',
    banner: {
      infoTitle: 'subscription.updatedPastDue.banner.info_title',
      infoMessage: 'subscription.updatedPastDue.banner.info_message',
      infoAction: 'subscription.updatedPastDue.banner.info_action',
    },
  },
  actions: {
    payMonthly: 'subscription.action.pay_monthly_button',
    payYearly: 'subscription.action.pay_yearly_button',
    monthlyPlansFree: 'subscription.action.choose_monthly_plans_free',
    yearlyPlansFree: 'subscription.action.choose_yearly_plans_free',
    monthlyPlansPaid: 'subscription.action.choose_monthly_plans_paid',
    yearlyPlansPaid: 'subscription.action.choose_yearly_plans_paid',
  },
  genericPaymentError: 'subscription.error.generic_error',
  contactUs: 'subscription.contact_us',
  askForAQuote: 'subscription.ask_for_a_quote',
  contactUsUrl: 'subscription.contact_us_url',
  paymentMethodReminderModal: {
    addPaymentMethodTitle: 'subscription.modal.add_payment_method_title',
    addPaymentMethodDescription: 'subscription.modal.add_payment_method_description',
  },
  invalidInfoHeader: 'vat.invalid_info_header',
  invalidReason1: 'vat.invalid_reason1',
  invalidReason2: 'vat.invalid_reason2',
  invalidReason3: 'vat.invalid_reason3',
  addVatNumber: 'vat.add',
  vatNumberPlaceholder: 'input.placeholder.VATNumber',
  tooltip: {
    header: 'vat.tooltip.header',
    body: {
      vat_FI: 'vat.tooltip.body.vat_FI',
      vat_DK: 'vat.tooltip.body.vat_DK',
    },
  },
  termsAndConditions: 'subscription.terms_and_conditions',
}
